import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import { useParams } from "react-router-dom";
import SvgImage from "../../../Icons/Icons";
import { AiOutlinePlus } from "react-icons/ai";
import { Button, Table } from "reactstrap";
import ReactPaginate from "react-paginate";
import { DatePickerField } from "../../../core/inputs/input";
import {
  cleanFastagTransactionHistory,
  getFastagTransactionHistory,
} from "../../../../services/Store/Actions/fastagAction";
import {
  cleanExpenseWalletSummary,
  getDriverListStatement,
  getExpenseWalletSummary,
} from "../../../../services/Store/Actions/driverslistActions";
import moment from "moment";
import AddingFilter from "../../../Modals/addingFilter";
import {
  cleanCardInventory,
  getCardInventory,
} from "../../../../services/Store/Actions/cardWalletAction";

const listing = ["Details", "Edit", "Delete"];
function InventoryTable(props) {
  let { inventoryStatus } = props;
  const dispatch = useDispatch();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [offset, setOffset] = useState(0);

  const [search, setSearch] = useState("");
  const { freightListCount, freightList } = useSelector((state) => state?.trip);
  console.log("=======>>>freightList>>>>", freightListCount, freightList);
  const [tripType, setTripType] = useState("");
  const [open2, setOpen2] = useState(false);
  const [editFreight, setEditFreight] = useState(false);
  const [vrn, setVrn] = useState("");
  const allFleets = useSelector((state) => state?.manageVehicle?.allFleets);
  const [dataCard, setDataCard] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const { inventory } = useSelector((state) => state?.cardWallet);
  const [active2, setActive2] = useState(false);
  const [txnRows,setTxnRows] = useState([])
  const txnCount = inventory?.length;
  console.log(
    "ffdfdfdfdfd",
    txnCount,
    txnRows,
    txnCount == undefined,
    txnCount == 0,
    txnCount > 0 && txnRows?.length == 0
  );
  const pageCount =
    txnCount % 10 === 0 ? txnCount / 10 : Math.floor(txnCount / 10) + 1;

  const handlePageClick = (event) => {
    console.log("Clickess", event, pageCount);
    const newOffset = event.selected * 10;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setOffset(newOffset);
  };
  const closing2 = () => {
    setActive2(false);
  };

  const toggling2 = () => {
    setActive2(!active2);
  };
  // const tripData = [];
  let { id } = useParams();
  const fetchUsers = async (page) => {
    console.log("kljkkkk", page.selected);
    dispatch(getCardInventory({}));
  };
  const handlePageChange = (page) => {
    setOffset(page.selected)
    console.log("kljkkkk", page.selected);
    let newA = inventory?.slice(page.selected*10,page.selected*10+10)
    setTxnRows(newA)
    // setOffset()
    // fetchUsers(page);
  };

  useEffect(() => {
    dispatch(
      getCardInventory({
        paid: tripType == "1" ? 1 : tripType == "2" ? "0" : null,
        status: tripType == "3" ? 1 : tripType == "4" ? "0" : null,
      })
    );
    return function cleanUp() {
      dispatch(cleanCardInventory());
    };
  }, [tripType, inventoryStatus]);

  useEffect(() => {
    let newA = inventory?.slice(0,10)
    setTxnRows(newA)
    if (tripType == "") {
      if (inventory?.length > 0) {
        let all = inventory?.length;
        let paid = inventory?.filter((e) => e?.isPaid == 1)?.length || 0;
        let unPaid = inventory?.filter((e) => e?.isPaid == 0)?.length || 0;
        let linked =
          inventory?.filter((e) => e?.phone && e?.phone != null)?.length || 0;
        let unLinked = inventory?.filter((e) => !e?.phone)?.length || 0;
        // console.log("mijojjnwe",          all,
        // paid,
        // unPaid,
        // linked,
        // unLinked,inventory)
        setDataCard({
          all,
          paid,
          unPaid,
          linked,
          unLinked,
        });
      }
    }
  }, [inventory]);

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const onSelect = (row) => {
    // storeDataToAsyncStorage("row", row);
    // navigate(`/trips/${row.tripId}`);
    // console.log("dsadasd", row);
    // // setItem(row);
    // console.log("thissssssssssssss", row);
  };
  return (
    <div className="box2">
      <div className="box3 d-flex">
        {/* <div className="ms-4">
          <div className="headingText">Date Range:</div>
          <input
            type="text"
            className="text-input-placeholder mt-2"
            placeholder={"Enter Date Range"}
            onChange={() => {}}
            value={""}
            // onkeypress={setStorage}
          />
        </div> */}
        {/* <div className="ms-4">
          <div className="headingText">To:</div>

        </div> */}
      </div>
      <div className="row box3 pt-0 justify-content-between">
        <div className="col-12 col-md-10">
          <button
            className={`Medium heading3 ${
              tripType == "" ? "greenButtonMini" : "greenOutlineButtonMini"
            } rounded-pill`}
            style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
            onClick={(e) => {
              setTripType("");
            }}
          >
            <div className="d-flex justify-content-between">
              <div style={{ paddingTop: "2px", marginRight: "8px" }}>All</div>
              <div
                className={` ${
                  tripType == "" ? "countAll" : "countAllInactive"
                }`}
              >
                {dataCard?.all || "0"}
              </div>
            </div>
          </button>
          <button
            className={`Medium heading3 ${
              tripType == "1" ? "greenButtonMini" : "greenOutlineButtonMini"
            } rounded-pill ms-3`}
            style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
            onClick={(e) => {
              setTripType("1");
            }}
          >
            <div className="d-flex justify-content-between">
              <div style={{ paddingTop: "2px", marginRight: "8px" }}>Paid</div>
              <div
                className={` ${
                  tripType == "1" ? "countAll" : "countAllInactive"
                }`}
              >
                {dataCard?.paid || "0"}
              </div>
            </div>
          </button>
          <button
            className={`Medium heading3 ${
              tripType == "2" ? "greenButtonMini" : "greenOutlineButtonMini"
            } rounded-pill ms-3`}
            style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
            onClick={(e) => {
              setTripType("2");
            }}
          >
            
            <div className="d-flex justify-content-between">
                  <div style={{ paddingTop: "2px", marginRight: "8px" }}>
                  Unpaid
                  </div>
                  <div className={` ${tripType == "2" ? "countAll" : "countAllInactive"}`}>
                    {dataCard?.unPaid || "0"}
                  </div>
                </div>
          </button>
          <button
            className={`Medium heading3 ${
              tripType == "3" ? "greenButtonMini" : "greenOutlineButtonMini"
            } rounded-pill ms-3`}
            style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
            onClick={(e) => {
              setTripType("3");
            }}
          >
            
            <div className="d-flex justify-content-between">
                  <div style={{ paddingTop: "2px", marginRight: "8px" }}>
                  Linked
                  </div>
                  <div className={` ${tripType == "3" ? "countAll" : "countAllInactive"}`}>
                    {dataCard?.linked || "0"}
                  </div>
                </div>
          </button>
          <button
            className={`Medium heading3 ${
              tripType == "4" ? "greenButtonMini" : "greenOutlineButtonMini"
            } rounded-pill ms-3`}
            style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
            onClick={(e) => {
              setTripType("4");
            }}
          >
                        <div className="d-flex justify-content-between">
                  <div style={{ paddingTop: "2px", marginRight: "8px" }}>
                  Unlinked
                  </div>
                  <div className={` ${tripType == "4" ? "countAll" : "countAllInactive"}`}>
                    {dataCard?.unLinked || "0"}
                  </div>
                </div>
            
          </button>
        </div>
      </div>
      <div className="table-for-vehicle-receivable">
        <Table className="vehicleAssignedHistory">
          <thead
            className="th align-middle text-center"
            style={{ zIndex: 99, textAlignLast: "center" }}
          >
            <tr className="table-header-Fastag-details">
              {/* <th className="p-0" style={{ width: "10%" }}>
                Lr No
              </th> */}
              <th
                // className="p-0"
                style={{
                  width: "25%",
                  textAlignLast: "left",
                  paddingLeft: "1rem",
                }}
              >
                Kit Number
              </th>
              <th
                // className="p-0"
                style={{
                  width: "13%",
                  textAlignLast: "left",
                  paddingLeft: "1rem",
                }}
              >
                Expiry Date
              </th>
              <th className="p-0">Phone</th>
              <th className="p-0">Payment Status</th>
              {/* <th className="p-0">Tonnage</th> */}
              <th className="p-0" style={{ width: "25%" }}>
                Card Number{" "}
              </th>
              {/* <th className="p-0">Trip No</th> */}
            </tr>
          </thead>
          {/* <div className="tbodyVehicle-div"> */}
          {txnCount == undefined ||
          txnCount == 0 ||
          (txnCount > 0 && txnRows?.length == 0) ? (
            <div className="padding32 textCenter">
              <SvgImage name="TripsMap" />
              {/* <div className="Bold heading1 padding24T padding16B FontSuperBold primaryBlack">
                Create Trip
              </div> */}
              <div className="greyFont heading3" style={{ marginTop: "10px" }}>
                There are no records to
              </div>
              <div className="greyFont heading3 padding32B">display</div>
              {/* <button
                className={"Medium heading3 greenButton"}
                style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
                onClick={() => {
                  setOpen2(true);
                }}
              >
                Create Trip
              </button> */}
            </div>
          ) : (
            <tbody className="tbodyVehicle" style={{ textDecoration: "none" }}>
              {txnRows?.map((items, i) => {
                return (
                  <>
                    <tr className="table-row-customer-details2">
                      <td
                        className="p-3"
                        onClick={() => {
                          onSelect(items);
                        }}
                        style={{ width: "25%", textAlignLast: "left" }}
                      >
                        {items?.kitNumber}
                      </td>
                      <td
                        className="p-3"
                        style={{ width: "13%", textAlignLast: "left" }}
                      >
                        {items?.expiryDate || "-"}
                      </td>
                      <td className="p-3">{items.phone || "-"}</td>
                      <td className="p-3">
                        <SvgImage name = "paidIcon"/>
                      </td>
                      <td className="p-3" style={{ width: "25%" }}>
                        {items?.cardNumber}
                      </td>
                      {/* <td
                        className="p-3"
                        onClick={() => {
                          onSelect(items?.Trip);
                        }}
                      >
                        {items?.tonnage}
                      </td> */}
                      {/* <td
                        className="p-3 align-items-center"
                        onClick={() => {
                          onSelect(items?.Trip);
                        }}
                      >
                        <div className="statusBtn">
                          {items?.Trip?.isActive == "0"
                            ? "Completed"
                            : "Running"}
                        </div>
                      </td> */}
                    </tr>
                  </>
                );
              })}
            </tbody>
          )}

          {/* </div> */}
        </Table>

        {/* {
          olderHistoryStatus?
          <div className="olderTransactions-div" onClick={handleOlderTransactions}>
          Older History
          </div>:
        <></>
        } */}
        {console.log("pagecunt", pageCount)}
        {pageCount >= 1 ? (
          <div className="reactPagination">
            <ReactPaginate
              breakLabel="..."
              nextLabel=" >"
              onPageChange={handlePageChange}
              pageRangeDisplayed={10}
              pageCount={pageCount}
              previousLabel="<"
              renderOnZeroPageCount={null}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              containerClassName={"pagination"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
export default InventoryTable;
